"use strict";
import Http from "./Http";
import abortMiddleware from "./middleware/abort";
import timeoutMiddleware from "./middleware/timeout";
export const http = new Http();
export * from "./interface";
export { abortMiddleware, Http, timeoutMiddleware };
//# sourceMappingURL=index.js.map
